import { colors } from "constants/colors";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Loading = () => {
  return (
    <LoadingWrapper>
      <LoadingSpinner />
    </LoadingWrapper>
  );
};

export default Loading;

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #eee;
  border-top: 2px solid ${colors.mainOrange};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: auto;
`;
